import { Component, Input, OnInit } from '@angular/core';
import { LogEvent } from 'src/app/interfaces/log';
import { GeneralService } from 'src/app/services/general/general.service';
import { KakaoService } from 'src/app/services/kakao/kakao.service';
import { LogService } from 'src/app/services/log/log.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { UserService } from 'src/app/services/user/user.service';
import { customLocalStorage } from 'src/utils/utils';

export const TermAgreementOpenedKey = 'term_agreement_opened';

@Component({
  selector: 'app-term-agreement',
  templateUrl: './term-agreement.component.html',
  styleUrls: ['./term-agreement.component.scss'],
})
export class TermAgreementComponent implements OnInit {

  constructor(
    private kakaoService: KakaoService,
    private modalService: ModalService,
    private generalService: GeneralService,
    private snackbarService: SnackbarService,
    private userService: UserService,
    private logService: LogService
  ) { }

  title = '';
  descriptions: string[] = [];
  button: { text: string; action: () => void } | undefined;

  @Input() notAllowedServiceTerms: string[] = [];
  private isLoggedIn: boolean = this.userService.isLoggedIn;

  ngOnInit() {
    customLocalStorage.setItem(TermAgreementOpenedKey, 'true');
    const termAgreement = this.termAgreementFactory();
    this.title = termAgreement.getTitle();
    this.descriptions = termAgreement.getDescriptions();
    this.button = termAgreement.getButton();
    this.logService.eventLogging(LogEvent.LOGIN_TERMS_GUIDE_DIALOG_VIEWED, { screenName: 'login', isLoggedIn: this.isLoggedIn });
  }

  onClickButton(): void {
    this.logService.eventLogging(LogEvent.LOGIN_TERMS_GUIDE_CONFIRM_CLICKED, { screenName: 'login', isLoggedIn: this.isLoggedIn });
    this.button?.action();
  }

  /**
   * 1. 앱 새로 설치 & 미가입 유저 : 공지 모달 표시
   * 2. 앱 새로 설치 & 가입 유저 : 공지 모달 표시
   * 3. 기존 앱 & 로그인 풀림 : 강제업 → 공지 모달 표시
   * 4. 기존 앱 & 로그인 유지 : 강제업 → 안내 모달 표시  
   * -> 결국 로그인한 유저만 안내모달 표시 
   */
  private termAgreementFactory(): TermAgreement {
    return this.isLoggedIn ? new TermAgreementAnnounce(
      this.kakaoService,
      this.generalService,
      this.snackbarService,
      this.notAllowedServiceTerms,
      this.modalService
    ) : new TermAgreementNotice(this.modalService);
  }
}

abstract class TermAgreement {
  
  constructor(protected modalService: ModalService) {
  }

  abstract getTitle(): string;
  abstract getDescriptions(): string[];
  abstract getButton (): { text: string; action: () => void };
}

class TermAgreementNotice extends TermAgreement {

  constructor(protected modalService: ModalService) {
    super(modalService);
  }

  getTitle(): string {
    return '추가 약관 동의화면이 표시되어도 놀라지 마세요!';
  }
  getDescriptions(): string[] {
    return [
      '2022년 7월 18일부로 타입스의 회원가입 절차가 개선되었습니다.',
      '👉 만 14세 미만이신 분들도 타입스를 이용할 수 있습니다.',
      '👉 카카오톡으로 타입스의 업데이트 안내 등 새소식을 받을 수 있습니다 (선택) ',
      '기존에 가입하셨더라도 서비스를 계속 이용하기 위해서는 개정된 약관에 동의가 필요합니다.'
    ];
  }
  getButton(): { text: string; action: () => void } {
    return {
      text: '계속 진행하기',
      action: () => this.modalService.dismiss(true)
    }
  }
}

class TermAgreementAnnounce extends TermAgreement {

  constructor(
    private kakaoService: KakaoService,
    private generalService: GeneralService,
    private snackbarService: SnackbarService,
    private notAllowedServiceTerms: string[],
    protected modalService: ModalService,
  ) {
    super(modalService);
  }

  private blockAgreeButton = false;

  getTitle(): string {
    return '회원가입 절차가 개선되었습니다 👏';
  }
  getDescriptions(): string[] {
    return [
      '👉 이제 만 14세 미만이신 분들도 타입스를 이용할 수 있습니다.',
      '👉 카카오톡으로 타입스의 업데이트 안내 등 새소식을 받을 수 있습니다 (선택)',
      '서비스를 계속 이용하기 위해서는 개정된 약관에 동의가 필요합니다.'
    ];
  }
  getButton(): { text: string; action: () => void } {
    return {
      text: '약관 동의하기 (필수)',
      action: () => this.onClickAgree()
    }
  }

  async onClickAgree(): Promise<void> {
    if (this.blockAgreeButton) {
      return;
    }
    this.blockAgreeButton = true;
    const loginResult = await this.kakaoService.login(undefined, this.notAllowedServiceTerms);

    if (loginResult && this.generalService.isApp) {
      this.snackbarService.openSnackBar(SnackbarService.AFTER_KAKAO_SYNC);
    }

    if (!loginResult) {
      this.blockAgreeButton = false;
      return;
    }

    // 성공했을 때만 dismiss 시키기
    const dismissTimeout = setTimeout(() => {
      this.modalService.dismiss();
      this.blockAgreeButton = false;
      clearTimeout(dismissTimeout);
    }, 1000);
  }

}